<template>
  <b-modal
    id="hospitalization-history-modal"
    title="Historique des estimations de sortie"
    :hide-footer="true"
  >
    <div v-if="hospitalization !== null">
      <b-list-group>
        <b-list-group-item v-for="(history, index) in hospitalizationHistories" :key="history.id">
          <div v-if="index === 0" class="font-weight-bold">{{new Date(history.presumedEndDate).toLocaleDateString()}} (prévision actuelle)</div>
          <div v-else>{{new Date(history.presumedEndDate).toLocaleDateString()}}</div>
        </b-list-group-item>
      </b-list-group>

    </div>
  </b-modal>
</template>

<script>
import api from '../../services/api';

export default {

  name: 'HospitalizationHistoryModal',

  props: {
    hospitalization: Object
  },

  data (){
    return{
      hospitalizationHistories: [],
    }
  },

  mounted (){
    this.fetchHistories()
  },

  methods: {

    fetchHistories(){
      api
        .get(`/hospitalizationHistory/getHistoriesByHospitalization?hospitalizationId=${this.hospitalization.id}`)
        .then(response => {
          this.hospitalizationHistories = response.data
        })
    },
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/hospitalization/HospitalizationHistoryModal.vue